import React from 'react';
import Dsy from './dsyui';
import { createComponent } from '@lit-labs/react';

const LitComp = Dsy.components.DsyDivider;

export const DsyDivider = createComponent(
  React,
  'dsy-divider',
  LitComp,
  {},
);
